import type * as Types from '../../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SaveFunnelSettingsMutationVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  settings: Types.YalperFunnelSettingsInput;
}>;


export type SaveFunnelSettingsMutationPage = { readonly __typename?: 'RootMutationType', readonly saveFunnelSettings: boolean };


export const SaveFunnelSettingsDocument = gql`
    mutation saveFunnelSettings($companyId: ID!, $settings: YalperFunnelSettingsInput!) {
  saveFunnelSettings(companyId: $companyId, settings: $settings)
}
    `;
export type SaveFunnelSettingsMutationFn = Apollo.MutationFunction<SaveFunnelSettingsMutationPage, SaveFunnelSettingsMutationVariables>;

/**
 * __useSaveFunnelSettingsMutation__
 *
 * To run a mutation, you first call `useSaveFunnelSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFunnelSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFunnelSettingsMutation, { data, loading, error }] = useSaveFunnelSettingsMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSaveFunnelSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SaveFunnelSettingsMutationPage, SaveFunnelSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveFunnelSettingsMutationPage, SaveFunnelSettingsMutationVariables>(SaveFunnelSettingsDocument, options);
      }
export type SaveFunnelSettingsMutationHookResult = ReturnType<typeof useSaveFunnelSettingsMutation>;
export type SaveFunnelSettingsMutationResult = Apollo.MutationResult<SaveFunnelSettingsMutationPage>;
export type SaveFunnelSettingsMutationOptions = Apollo.BaseMutationOptions<SaveFunnelSettingsMutationPage, SaveFunnelSettingsMutationVariables>;